import { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Form, ListGroup } from 'react-bootstrap';
import { getLocations } from '../../services/Configs/LocationsService';
import { getStatuses } from '../../services/Other/GeneralQueries';
import { getAll } from '../../services/Users/Users';
import { toast } from 'react-toastify';

function JustifyInventoryOutput({
    show,
    handleClose,
    differenceInQuantity,
    selectedStatuses,
    setSelectedStatuses,
    selectedLocations,
    setSelectedLocations,
    selectedUsers,
    setSelectedUsers,
    onSave,
    setJustifyBy,
    justifyBy,
    isSaveDisabled
}) {
    // Estado para almacenar el valor seleccionado=
    const [locations, setLocations] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [users, setUsers] = useState([]);

    const handleRadioChange = (e) => {
        setJustifyBy(e.target.id); // Establece el id del botón seleccionado
    };

    const handleStatusDdChange = (e) => {
        let { id, value } = e.target;

        if (parseInt(value) === 0) {
            setSelectedStatuses((prevStatuses) =>
                prevStatuses.filter((status) => status.id !== id)
            );
        } else {
            setSelectedStatuses((prevStatuses) => {
                const statusExists = prevStatuses.some((status) => status.id === id);
                if (statusExists) {
                    return prevStatuses.map((status) =>
                        status.id === id ? { ...status, value: parseInt(value) } : status
                    );
                } else {
                    return [...prevStatuses, { id, value: parseInt(value) }];
                }
            });
        }
    };

    const handleLocationDdChange = (e) => {
        let { id, value } = e.target;

        if (parseInt(value) === 0) {
            setSelectedLocations((prevLocations) =>
                prevLocations.filter((location) => location.id !== id)
            );
        } else {
            setSelectedLocations((prevLocations) => {
                const locationExists = prevLocations.some((location) => location.id === id);
                if (locationExists) {
                    return prevLocations.map((location) =>
                        location.id === id ? { ...location, value: parseInt(value) } : location
                    );
                } else {
                    return [...prevLocations, { id, value: parseInt(value) }];
                }
            });
        }
    };

    const handleUsersDdChange = (e) => {
        let { id, value } = e.target;

        if (parseInt(value) === 0) {
            setSelectedUsers((prevUsers) =>
                prevUsers.filter((user) => user.id !== id)
            );
        } else {
            setSelectedUsers((prevUsers) => {
                const userExists = prevUsers.some((user) => user.id === id);
                if (userExists) {
                    return prevUsers.map((user) =>
                        user.id === id ? { ...user, value: parseInt(value) } : user
                    );
                } else {
                    return [...prevUsers, { id, value: parseInt(value) }];
                }
            });
        }
    };

    useEffect(() => {
        getLocations().then((list) => {
            setLocations(list);
        });

        getStatuses().then((list) => {
            setStatuses(list);
        });

        getAll().then((list) => {
            setUsers(list);
        });
    }, []);

    return (
        <>
            <Modal size="lg" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Justificar salida de inventario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='mb-2'>
                        <Col xs={6}>
                            <Form.Label>
                                ¿Cómo quieres justificar los objetos? (Cantidad {differenceInQuantity})
                            </Form.Label>
                        </Col>
                        <Col xs={6}>
                            <Form.Check
                                inline
                                label="En grupo"
                                name="justifyBy"
                                type="radio"
                                id="byGroup"
                                onChange={handleRadioChange}
                                checked={justifyBy === 'byGroup'} // Marca como seleccionado si coincide con el estado
                            />
                            <Form.Check
                                inline
                                label="Individual"
                                name="justifyBy"
                                type="radio"
                                id="byIndividual"
                                onChange={handleRadioChange}
                                checked={justifyBy === 'byIndividual'} // Marca como seleccionado si coincide con el estado
                            />
                        </Col>
                    </Row>
                    {
                        justifyBy == '' ?
                            null :
                            justifyBy == 'byGroup' ?
                                <>
                                    <ListGroup>
                                        <ListGroup.Item action variant="secondary">
                                            <Row>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>Estado (obligatorio):</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name={`statusId_0`}
                                                            id={`statusId_0`}
                                                            onChange={handleStatusDdChange}
                                                        >
                                                            <option value={0}>Seleccionar estado</option>
                                                            {statuses.map((status) => (
                                                                <option key={status.id} value={status.id}>{status.name}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>Ubicación (obligatorio):</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name={`locationId_0`}
                                                            id={`locationId_0`}
                                                            onChange={handleLocationDdChange}
                                                        >
                                                            <option value={0}>Seleccionar ubicación</option>
                                                            {locations.map((location) => (
                                                                <option key={location.id} value={location.id}>{location.name}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>Asignado a (opcional):</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name={`assignedToId_0`}
                                                            id={`assignedToId_0`}
                                                            onChange={handleUsersDdChange}
                                                        >
                                                            <option value={0}>Seleccionar usuario</option>
                                                            {users.map((user) => (
                                                                <option key={user.id} value={user.id}>{user.userName} - {user.email}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </>
                                :
                                <>
                                    <ListGroup>
                                        {
                                            Array.from({ length: differenceInQuantity }).map((_, index) => (
                                                <ListGroup.Item action variant="secondary">
                                                    <Row className="mb-3" >
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Estado (obligatorio):</Form.Label>
                                                                <Form.Control
                                                                    as="select"
                                                                    name={`statusId_${index}`} // Aseguramos que el nombre sea único    
                                                                    id={`statusId_${index}`}
                                                                    onChange={handleStatusDdChange}
                                                                >
                                                                    <option value={0}>Seleccionar estado</option>
                                                                    {statuses.map((status) => (
                                                                        <option key={status.id} value={status.id}>{status.name}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Ubicación (obligatorio):</Form.Label>
                                                                <Form.Control
                                                                    as="select"
                                                                    name={`locationId_${index}`} // Aseguramos que el nombre sea único    
                                                                    id={`locationId_${index}`}
                                                                    onChange={handleLocationDdChange}
                                                                >
                                                                    <option value={0}>Seleccionar ubicación</option>
                                                                    {locations.map((location) => (
                                                                        <option key={location.id} value={location.id}>{location.name}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Asignado a (opcional):</Form.Label>
                                                                <Form.Control
                                                                    as="select"
                                                                    name={`assignedToId_${index}`} // Aseguramos que el nombre sea único          
                                                                    id={`assignedToId_${index}`}
                                                                    onChange={handleUsersDdChange}
                                                                >
                                                                    <option value={0}>Seleccionar usuario</option>
                                                                    {users.map((user) => (
                                                                        <option key={user.id} value={user.id}>{user.userName} - {user.email}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            ))
                                        }
                                    </ListGroup>
                                </>
                    }
                    <Row className='mt-2'>
                        <Col>
                            <div role="warning" class="fade alert alert-warning show">
                                <div class="alert-heading h6"><span class="admonitionIcon_Ibzs">	Al guardar, cada objeto se generará individualmente con su respectivo estado, ubicación o asignación. Es obligatorio justificar estos cambios para mantener la integridad y precisión del inventario.</span>
                                </div><div class="admonitionContent_vXIg"></div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={onSave} disabled={isSaveDisabled}>
                        Guardar
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default JustifyInventoryOutput;